export enum SignatureProviderTypeEnum {
    Eseal = 'AdssSignatureProvider',
    TokenCertificateSignatureProvider = 'TokenCertificateSignatureProvider',
    HardTokenAgentSignatureProvider = 'HardTokenAgentSignatureProvider',
    CscV1SignatureProvider = 'CscV1SignatureProvider',
    CscSignatureProvider = 'CscSignatureProvider'
}